import { render } from "./Forvaltare.vue?vue&type=template&id=8736ce5c&scoped=true"
import script from "./Forvaltare.vue?vue&type=script&lang=js"
export * from "./Forvaltare.vue?vue&type=script&lang=js"

import "./Forvaltare.vue?vue&type=style&index=0&id=8736ce5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8736ce5c"],['__file',"src/views/Forvaltare.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8736ce5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8736ce5c', __exports__)) {
    api.reload('8736ce5c', __exports__)
  }
  
  module.hot.accept("./Forvaltare.vue?vue&type=template&id=8736ce5c&scoped=true", () => {
    api.rerender('8736ce5c', render)
  })

}


export default __exports__